export { CnPageFooter } from '@cainiaofe/cn-ui';
